module.exports = __webpack_public_path__ + "static/img/ma.7fe34c1e.svg";